<template>
  <div class="member-settings-container">
    <!-- 页面级别的loading覆盖层 -->
    <el-loading 
      v-loading="pageLoading" 
      text="处理中..." 
      class="page-loading"
      background="rgba(255, 255, 255, 0.8)"
    ></el-loading>
    
    <h1 class="page-title">会员设置</h1>
        <!-- 会员注册设置 -->
    <el-card v-loading="registerLoading" element-loading-text="加载中..." class="content-card">
      <template #header>
        <div class="card-header">
          <h2>会员注册设置</h2>
        </div>
      </template>
      <div class="card-content">
        <el-form label-width="120px" class="member-form">
          <!-- 注册选项 -->
          <el-form-item label="允许自助注册" v-if="1===0">
            <el-switch active-text="允许" inactive-text="禁止" v-model="registerSettings.allowSelfRegister"></el-switch>
          </el-form-item>
          
          <el-form-item label="注册验证码"  v-if="1===0">
            <el-switch active-text="开启" inactive-text="关闭" v-model="registerSettings.enableCaptcha"></el-switch>
          </el-form-item>
          
          <el-form-item label="注册赠送优惠券"  v-if="1===0">
            <el-switch active-text="开启" inactive-text="关闭" v-model="registerSettings.giveCouponOnRegister"></el-switch>
          </el-form-item>
          
          <!-- 新增配置项：注册赠送积分 -->
          <el-form-item label="注册赠送积分">
            <el-switch active-text="开启" inactive-text="关闭" v-model="registerSettings.givePointsOnRegister"></el-switch>
          </el-form-item>
          
          <el-form-item label="赠送积分数量" v-if="registerSettings.givePointsOnRegister">
            <el-input-number 
              v-model="registerSettings.registerPointsAmount" 
              :min="0" 
              :step="10" 
              placeholder="请输入赠送积分数量"
              style="width: 200px;">
            </el-input-number>
            <div class="form-tip">用户注册成功后将获得对应积分</div>
          </el-form-item>
          
          <!-- 新增配置项：注册后自动成为 -->
          <el-form-item label="注册后自动成为" prop="defaultMemberLevel">
          <el-select v-model="registerSettings.defaultMemberLevel" placeholder="请选择默认会员等级">
            <el-option 
              v-for="level in memberLevels" 
              :key="level.id || level.sortOrder" 
              :label="level.levelName" 
              :value="level.id ? level.id.toString() : ''">
            </el-option>
          </el-select>
          <div class="form-tip">用户注册后将自动获得所选会员等级</div>
        </el-form-item>
          
          <!-- 表单按钮 -->
          <el-form-item>
            <el-button type="primary" @click="saveRegisterSettings" :loading="savingRegisterSettings">保存配置</el-button>
            <el-button @click="loadRegisterSettings">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 会员等级设置 -->
    <el-card v-loading="levelLoading" element-loading-text="加载中..." class="content-card">
      <template #header>
        <div class="card-header">
          <h2>会员等级设置</h2>
        </div>
      </template>
      <div class="card-content">
        <el-form label-width="120px" class="member-form">
          <el-divider>会员等级列表</el-divider>
          
          <!-- 等级列表 -->
          <div class="level-list-container">
            <div class="add-level-button">
              <el-button type="primary" @click="addMemberLevel">
                <el-icon><Plus /></el-icon>
                添加会员等级
              </el-button>
            </div>
            
            <!-- 等级列表为空时的提示 -->
            <div v-if="memberLevels.length === 0" class="no-levels">
              暂无会员等级，点击"添加会员等级"按钮开始添加
            </div>
            
            <!-- 等级列表 -->
            <div v-for="(level, index) in memberLevels" :key="index" class="level-item">
              <el-collapse v-model="activeNames" accordion>
                <el-collapse-item :name="index">
                  <template #title>
                    <div class="collapse-title-container">
                      <span>{{ level.levelName || '未命名等级' }} (等级 {{ index + 1 }})</span>
                      <el-button style="margin-right: 50px;" type="danger" size="small" @click="deleteMemberLevel(index)">
                        <el-icon><Delete /></el-icon>
                        删除
                      </el-button>
                    </div>
                  </template>
                  <div class="level-config">
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="等级名称">
                          <el-input v-model="level.levelName" placeholder="请输入会员等级名称"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="等级排序">
                          <el-input-number 
                            v-model="level.sortOrder" 
                            :min="0" 
                            :step="1" 
                            placeholder="请输入等级排序"></el-input-number>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="背景图片">
                          <div class="background-selector">
                            <div 
                              v-for="background in memberLevelBackgrounds" 
                              :key="background.name"
                              class="background-item"
                              :class="{ 'active': level.backgroundImage === background.name }"
                              @click="level.backgroundImage = background.name"
                            >
                              <img :src="background.url" :alt="background.name" class="background-image" />
                              <span class="background-name">{{ background.name }}</span>
                            </div>
                          </div>
                          <div class="form-tip">
                            选择会员等级的背景图片，用于在会员中心展示
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-divider>升级条件</el-divider>
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="升级金额">
                          <div class="input-with-suffix">
                            <el-input-number 
                              v-model="level.upgradeAmount" 
                              :min="0" 
                              :precision="2" 
                              :step="100" 
                              placeholder="请输入升级消费金额"
                              class="suffix-input">
                            </el-input-number>
                            <span class="input-suffix">元</span>
                          </div>
                          <div class="form-tip">不包含小程序商城消费</div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-if="false">
                        <el-form-item label="升级积分">
                          <el-input-number 
                            v-model="level.upgradePoints" 
                            :min="0" 
                            :step="100" 
                            placeholder="请输入升级所需积分"></el-input-number>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-divider>等级权益</el-divider>
                    <el-row :gutter="20" v-if="false">
                      <el-col :span="12">
                        <el-form-item label="会员折扣">
                          <el-input-number 
                            v-model="level.discount" 
                            :min="0" 
                            :max="10" 
                            :precision="1" 
                            :step="0.5" 
                            placeholder="请输入会员折扣">
                            <template #append>折</template>
                          </el-input-number>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="生日特权">
                          <el-input-number 
                            v-model="level.birthdayBenefit" 
                            :min="0" 
                            :precision="1" 
                            :step="0.5" 
                            placeholder="请输入生日特权倍数">
                            <template #append>倍积分</template>
                          </el-input-number>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="升级积分奖励">
                          <el-input-number 
                            v-model="level.upgradeRewardPoints" 
                            :min="0" 
                            :step="10" 
                            :precision="0" 
                            placeholder="请输入升级到该等级时奖励的积分数量">
                          </el-input-number>
                          <div class="form-tip">用户升级到该等级时将获得对应积分奖励</div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-divider>会员周期</el-divider>
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item label="会员周期">
                          <div class="input-with-suffix">
                            <el-input-number 
                              v-model="level.cycleDays" 
                              :min="1" 
                              :step="1" 
                              placeholder="请输入会员周期天数"
                              class="suffix-input">
                            </el-input-number>
                            <span class="input-suffix">天</span>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="降级阈值">
                          <div class="input-with-suffix">
                            <el-input-number 
                              v-model="level.downgradeThreshold" 
                              :min="0" 
                              :precision="2" 
                              :step="100" 
                              placeholder="请输入降级消费阈值"
                              class="suffix-input">
                            </el-input-number>
                            <span class="input-suffix">元</span>
                          </div>
                          <div class="form-tip">上一个周期消费不满该金额将降级</div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label="会员权益">
                          <el-checkbox-group 
                            v-model="level.benefits" 
                            class="benefit-checkbox-group"
                            @change="updateBenefitCounts(level)"
                          >
                            <div v-for="benefit in memberBenefits" :key="benefit.id" class="benefit-item">
                              <el-checkbox 
                                :label="benefit.id" 
                                class="benefit-checkbox">
                                {{ benefit.name }}
                                <span v-if="benefit.coupon_id" class="coupon-tag">
                                  <el-tag size="small" type="success">已绑定优惠券</el-tag>
                                </span>
                              </el-checkbox>
                              <!-- 当权益绑定了优惠券且被勾选时，显示次数输入框 -->
                              <el-input-number
                                  v-if="benefit.coupon_id && level.benefits.includes(benefit.id)"
                                  v-model="level.benefit_counts[benefit.id]"
                                  :min="1"
                                  :step="1"
                                  :precision="0"
                                  placeholder="请输入使用次数"
                                  class="benefit-count-input"
                                >
                                  <template #append>次</template>
                                </el-input-number>
                            </div>
                          </el-checkbox-group>
                          <div v-if="memberBenefits.length === 0" class="no-benefits-tip">
                            暂无可用会员权益，请先在会员权益管理中添加
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          
          <!-- 表单按钮 -->
          <el-form-item>
            <el-button type="primary" @click="saveMemberLevels" :loading="savingMemberLevels">保存配置</el-button>
            <el-button @click="loadMemberLevels">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    

  </div>
</template>

<script setup>
/* eslint-disable */
import { reactive, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Plus, Delete } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { fetchMemberLevelList, addMemberLevel as apiAddMemberLevel, updateMemberLevel as apiUpdateMemberLevel, deleteMemberLevel as apiDeleteMemberLevel, fetchBenefitList, getRegisterSettings, saveRegisterSettings as saveRegisterSettingsApi, fetchMemberLevelBackgrounds } from '@/api/member';

// 注册设置加载状态
const registerLoading = ref(true);
// 会员等级设置加载状态
const levelLoading = ref(true);
// 保存注册设置的加载状态
const savingRegisterSettings = ref(false);
// 保存会员等级配置的加载状态
const savingMemberLevels = ref(false);
// 页面全局loading状态
const pageLoading = ref(false);

// 路由实例
const router = useRouter();

// 初始数据加载
onMounted(() => {
  loadMemberLevels();
  loadMemberBenefits();
  loadRegisterSettings();
  loadMemberLevelBackgrounds();
});

// 会员等级列表
const memberLevels = reactive([]);

// 会员权益列表
const memberBenefits = reactive([]);

// 会员等级背景图片列表
const memberLevelBackgrounds = reactive([]);

// 获取会员等级背景图片列表
const loadMemberLevelBackgrounds = async () => {
  pageLoading.value = true;
  try {
    // 使用本地 1-6 会员背景图片
    memberLevelBackgrounds.length = 0;
    
    const localBackgrounds = [
      { name: 'level_1', url: require('@/assets/1.png') },
      { name: 'level_2', url: require('@/assets/2.png') },
      { name: 'level_3', url: require('@/assets/3.png') },
      { name: 'level_4', url: require('@/assets/4.png') },
      { name: 'level_5', url: require('@/assets/5.png') },
      { name: 'level_6', url: require('@/assets/6.png') }
    ];
    
    localBackgrounds.forEach(background => {
      memberLevelBackgrounds.push(background);
    });
  } catch (error) {
    console.error('获取会员等级背景图片列表失败:', error);
    ElMessage.error('获取会员等级背景图片列表失败');
  } finally {
    pageLoading.value = false;
  }
};

// 注册设置
const registerSettings = reactive({
  allowSelfRegister: true,
  enableCaptcha: false,
  giveCouponOnRegister: false,
  givePointsOnRegister: false,
  registerPointsAmount: 0,
  defaultMemberLevel: ''
});

// 折叠面板激活项
let activeNames = reactive(['0']);

// 获取权益使用次数
const getBenefitCount = (level, benefitId) => {
  // 确保level.benefit_counts是对象类型
  if (!level.benefit_counts) {
    level.benefit_counts = {};
  }
  // 如果benefitId对应的次数不存在，初始化为1
  if (level.benefit_counts[benefitId] === undefined) {
    level.benefit_counts[benefitId] = 1;
  }
  return level.benefit_counts[benefitId];
};

// 监听权益变化，确保benefit_counts对象正确更新
const updateBenefitCounts = (level) => {
  // 确保level.benefit_counts是对象类型
  if (!level.benefit_counts) {
    level.benefit_counts = {};
  }
  
  // 遍历所有权益，确保勾选的权益有对应的计数
  level.benefits.forEach(benefitId => {
    if (level.benefit_counts[benefitId] === undefined) {
      level.benefit_counts[benefitId] = 1;
    }
  });
  
  // 清除未勾选权益的计数
  Object.keys(level.benefit_counts).forEach(benefitId => {
    if (!level.benefits.includes(parseInt(benefitId))) {
      delete level.benefit_counts[benefitId];
    }
  });
};

// 加载会员等级列表
const loadMemberLevels = async () => {
  pageLoading.value = true;
  levelLoading.value = true;
  try {
    const response = await fetchMemberLevelList();
    if (response.code === 200) {
      memberLevels.length = 0;
      // 检查response.data是否为数组，如果是直接使用，否则检查是否包含data属性
      const levelsData = Array.isArray(response.data) ? response.data : (response.data.data || []);
      levelsData.forEach(level => {
        // 确保 benefits 始终是数组类型
        const benefits = Array.isArray(level.benefits) ? level.benefits : [];
        // 确保 benefit_counts 是对象类型
        const benefitCounts = typeof level.benefit_counts === 'object' && level.benefit_counts !== null ? level.benefit_counts : {};
        memberLevels.push({
            id: level.id,
            levelName: level.level_name,
            sortOrder: level.sort_order,
            upgradeAmount: parseFloat(level.upgrade_amount),
            upgradePoints: level.upgrade_points,
            discount: level.discount ? parseFloat(level.discount) : null,
            birthdayBenefit: level.birthday_benefit ? parseFloat(level.birthday_benefit) : null,
            upgradeRewardPoints: level.upgrade_reward_points || 0,
            status: level.status,
            cycleDays: level.cycle_days || 365,
            downgradeThreshold: parseFloat(level.downgrade_threshold || 0),
            benefits: benefits,
            benefit_counts: benefitCounts,
            backgroundImage: level.background_image || ''
        });
      });
    } else {
      ElMessage.error('加载会员等级失败：' + response.message);
    }
  } catch (error) {
    ElMessage.error('加载会员等级失败：' + error.message);
  } finally {
    levelLoading.value = false;
    pageLoading.value = false;
  }
};

// 加载会员权益列表
const loadMemberBenefits = async () => {
  pageLoading.value = true;
  levelLoading.value = true;
  try {
    const response = await fetchBenefitList();
    if (response.code === 200) {
      memberBenefits.length = 0;
      // 后端返回的数据结构包含分页信息，真正的权益数组在response.data.data中
      const benefitsData = response.data.data || [];
      benefitsData.forEach(benefit => {
        memberBenefits.push(benefit);
      });
    } else {
      ElMessage.error('加载会员权益失败：' + response.message);
    }
  } catch (error) {
    ElMessage.error('加载会员权益失败：' + error.message);
  } finally {
    levelLoading.value = false;
    pageLoading.value = false;
  }
};

// 添加会员等级
const addMemberLevel = () => {
  memberLevels.push({
    id: '',
    levelName: '',
    sortOrder: memberLevels.length + 1,
    upgradeAmount: 0,
    upgradePoints: 0,
    discount: 10,
    birthdayBenefit: 1,
    upgradeRewardPoints: 0,
    status: true,
    cycleDays: 365,
    downgradeThreshold: 0,
    benefits: [],
    benefit_counts: {},
    backgroundImage: ''
  });
};

// 删除会员等级
const deleteMemberLevel = async (index) => {
  try {
    const level = memberLevels[index];
    if (level.id) {
      // 调用API删除
      const response = await apiDeleteMemberLevel(level.id);
      if (response.code === 200) {
        memberLevels.splice(index, 1);
        ElMessage.success('删除会员等级成功');
      } else {
        ElMessage.error('删除会员等级失败：' + response.message);
      }
    } else {
      // 直接从本地数组删除
      memberLevels.splice(index, 1);
    }
  } catch (error) {
    ElMessage.error('删除会员等级失败：' + error.message);
  }
};

// 保存会员等级配置
const saveMemberLevels = async () => {
  pageLoading.value = true;
  savingMemberLevels.value = true;
  try {
    // 验证数据
    for (let i = 0; i < memberLevels.length; i++) {
      if (!memberLevels[i].levelName) {
        ElMessage.warning(`第${i + 1}个等级的名称不能为空`);
        return;
      }
    }

    // 处理每个等级
    for (const level of memberLevels) {
      // 构建请求数据，只包含有效字段
      const levelData = {
        level_name: level.levelName,
        sort_order: level.sortOrder,
        upgrade_amount: level.upgradeAmount,
        upgrade_points: level.upgradePoints,
        upgrade_reward_points: level.upgradeRewardPoints,
        status: level.status,
        cycle_days: level.cycleDays,
        downgrade_threshold: level.downgradeThreshold,
        background_image: level.backgroundImage,
        benefits: level.benefits,
        benefit_counts: level.benefit_counts
      };
      
      // 只有当 discount 不是 null 时才添加到请求数据中
      if (level.discount !== null && level.discount !== undefined) {
        levelData.discount = level.discount;
      }
      
      // 只有当 birthday_benefit 不是 null 时才添加到请求数据中
      if (level.birthdayBenefit !== null && level.birthdayBenefit !== undefined) {
        levelData.birthday_benefit = level.birthdayBenefit;
      }

      if (level.id) {
        // 更新现有等级
        await apiUpdateMemberLevel(level.id, levelData);
      } else {
        // 创建新等级
        await apiAddMemberLevel(levelData);
      }
    }

    // 重新加载数据，确保ID等字段正确
    await loadMemberLevels();
    ElMessage.success('保存会员等级配置成功');
    // 跳转到会员列表页面
    router.push('/member/list');
  } catch (error) {
    ElMessage.error('保存会员等级配置失败：' + error.message);
  } finally {
    savingMemberLevels.value = false;
    pageLoading.value = false;
  }
};

// 保存注册设置
const saveRegisterSettings = async () => {
  pageLoading.value = true;
  savingRegisterSettings.value = true;
  try {
    const response = await saveRegisterSettingsApi(registerSettings);
    if (response.code === 200) {
      ElMessage.success('保存注册设置成功');
      // 保存成功后重新加载数据
      loadRegisterSettings();
    } else {
      ElMessage.error('保存注册设置失败：' + response.message);
    }
  } catch (error) {
    ElMessage.error('保存注册设置失败：' + error.message);
  } finally {
    savingRegisterSettings.value = false;
    pageLoading.value = false;
  }
};

// 加载注册设置
const loadRegisterSettings = async () => {
  pageLoading.value = true;
  registerLoading.value = true;
  try {
    const response = await getRegisterSettings();
    if (response.code === 200) {
      const settingsData = response.data;
      // 确保defaultMemberLevel是字符串类型
      if (settingsData.defaultMemberLevel) {
        settingsData.defaultMemberLevel = settingsData.defaultMemberLevel.toString();
      }
      Object.assign(registerSettings, settingsData);
    } else {
      ElMessage.error('加载注册设置失败：' + response.message);
    }
  } catch (error) {
    ElMessage.error('加载注册设置失败：' + error.message);
  } finally {
    registerLoading.value = false;
    pageLoading.value = false;
  }
};
</script>

<style scoped>
.member-settings-container {
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.content-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.card-content {
  padding: 20px 0;
}

.member-form {
  margin-top: 20px;
}

.member-form .el-form-item {
  margin-bottom: 25px;
}

/* 会员等级列表样式 */
.level-list-container {
  margin-top: 20px;
}

.add-level-button {
  margin-bottom: 15px;
}

.no-levels {
  text-align: center;
  padding: 20px 0;
  color: #999;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 15px;
}

.level-item {
  margin-bottom: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}

.level-config {
  padding: 20px;
  background-color: #fafafa;
}

.level-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 折叠面板标题容器样式 */
.collapse-title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/* 调整折叠面板样式 */
.level-item :deep(.el-collapse-item__header) {
  padding: 15px 20px;
  background-color: #f0f2f5;
  border-bottom: 1px solid #ebeef5;
}

.level-item :deep(.el-collapse-item__content) {
  padding: 0;
  background-color: #fff;
}

/* 调整折叠面板标题按钮间距 */
.level-item :deep(.el-collapse-item__header .el-button) {
  margin-left: 10px;
}

/* 会员权益选择样式 */
.benefit-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
}

.benefit-item {
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.benefit-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 20px;
}

.coupon-tag {
  margin-left: 8px;
}

.benefit-count-input {
  width: 150px;
  margin-left: 10px;
}

.no-benefits-tip {
  margin-top: 10px;
  color: #909399;
  font-size: 14px;
  background-color: #f5f7fa;
  padding: 10px;
  border-radius: 4px;
}

/* 表单提示文字样式 */
.form-tip {
  margin-top: 8px;
  color: #909399;
  font-size: 13px;
  line-height: 1.4;
}

/* 自定义输入框后缀样式 */
.input-with-suffix {
  position: relative;
  display: inline-block;
  width: 100%;
}

.suffix-input {
  width: calc(100% - 30px);
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-suffix {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 10px;
  line-height: 32px;
  color: #606266;
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-left: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

/* 背景图片选择器样式 */
.background-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 10px;
}

.background-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border: 2px solid #e4e7ed;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100px;
}

.background-item:hover {
  border-color: #409eff;
  background-color: #ecf5ff;
}

.background-item.active {
  border-color: #67c23a;
  background-color: #f0f9eb;
}

.background-image {
  width: 80px;
  height: 60px;
  object-fit: cover;
  margin-bottom: 5px;
  border-radius: 4px;
}

.background-name {
  font-size: 12px;
  color: #606266;
  text-align: center;
}
</style>